import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { redirect } from "react-router-dom";
import { useState, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import Tooltip from "@mui/material/Tooltip";
import {
  Typography,
  Modal,
  Box,
} from "@mui/material";
import { CognitoUserContext } from "../contexts/cognitoUserContext.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

// So here we can grab the url and read in the details for the sub_id
// We can then make a call to cognito to get the latest attributes presumbly.

// Note: This env variable is set by Amplify and used for direct Cognito user updates
const USERPOOL_ID = process.env.AUTH_GAMMA6070A913_USERPOOLID;

const searchString = window.location.search;
const params = new URLSearchParams(searchString);

const sub_id = params.get("sub_id");

function Success() {
  const { setCognitoUser } = useContext(CognitoUserContext);
  const [modalOpen, setModalOpen] = useState(true);
  const nav = useNavigate();
  // The call below should somehow reload the Cognito user attributes
  const handleModalClose = () => {
    setModalOpen(false);

    loader();
    // Does the nav but nothing in the home triggers any events
    nav("/");
  };

  // Legacy function: Direct Cognito user attribute update
  // Note: This is currently disabled (not called). Subscription expiry is managed via Stripe webhooks.
  // eslint-disable-next-line no-unused-vars
  const updateuser = async () => {
    // Calculate subscription expiry: current time + 30 days (2629746000ms)
    const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000; // 2629746000ms
    const expiryDate = `${new Date().getTime() + THIRTY_DAYS_MS}`;
    await Auth.updateUserAttributes(
      {
        UserAttributes: [
          /* required */
          {
            Name: "custom:stripeSubExpiry" /* required */,
            Value: expiryDate,
          },
        ],
        UserPoolId: USERPOOL_ID /* required */,
        Username: sub_id /* required */,
      },
      function (err, data) {
        if (err) console.log(err, err.stack);
        else {
          //res.sendStatus(200);
        }
      }
    );
  };

  const loader = async () => {
    // updateuser();
    const session = await Auth.currentSession();
    if (sub_id === session.accessToken.payload.sub) {
      
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      /*
      expiryDate = `${new Date().getTime() + 2629746000}`; // Hack for one month
      await Auth.updateUserAttributes(user, {
        "custom:stripeSubExpiry": expiryDate,
      });
      user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      */
      setCognitoUser(user); // Update context with refreshed user attributes
      // Here we could get the sub, sessionid and pssibly expiry dates,compare them
      // to the response (params) and if they match, set the expiry date and save it back
    }
    return redirect("/");
  };

  return (
    <div>
      <Modal  open={modalOpen}>
        <Box>
          <Box sx={style}>
            <Typography id="spring-modal-title" variant="h6" component="h2">
              Congratulations, You've joined us!
            </Typography>
            <Typography id="spring-modal-title" variant="h6" component="h2">
              Go find some politicians...
            </Typography>

            <Tooltip title="Collect Some People...">
              <IconButton sx={{ color: "red" }} onClick={handleModalClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <SubscriptionsIcon />
        </Box>
      </Modal>
    </div>
  );
}
export default Success;
